export enum NodeType {
    Form = 'Form',
    TeamReview = 'TeamReview',
    AutomatedAction = 'AutomatedAction',
    Consultation = 'Consultation',
    SecurityDeposit = 'SecurityDeposit',
    Invoice = 'Invoice',
    Appointment = 'Appointment',
}
